import {
  Drawer,
  Toolbar,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Box,
  IconButton,
} from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import SummarizeTwoToneIcon from "@mui/icons-material/SummarizeTwoTone";
import CloseIcon from "@mui/icons-material/Close";
import DashboardIcon from "@mui/icons-material/Dashboard";
import LockClockIcon from "@mui/icons-material/LockClock";
import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import PeopleIcon from "@mui/icons-material/People";
import BarChartIcon from "@mui/icons-material/BarChart";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import PsychologyIcon from "@mui/icons-material/Psychology";
import SubscriptionsIcon from "@mui/icons-material/Subscriptions";
import FeaturedVideoIcon from "@mui/icons-material/FeaturedVideo";
import QuizIcon from "@mui/icons-material/Quiz";
import SavingsIcon from "@mui/icons-material/Savings";
import Person3Icon from "@mui/icons-material/Person3";
import NoteIcon from "@mui/icons-material/Note";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import PaidIcon from "@mui/icons-material/Paid";
import ContentPasteIcon from "@mui/icons-material/ContentPaste";
import { PropsWithoutRef } from "react";
import { SIDEBAR_WIDTH } from "../helpers/constants/SideBarWidth";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import Settings from "@mui/icons-material/Settings";
import DuoIcon from '@mui/icons-material/Duo';
import KeyboardReturnIcon from '@mui/icons-material/KeyboardReturn';
interface Props {
  mobileOpen: boolean;
  handleSidebarToggle: () => void;
}

export default function Sidebar({
  mobileOpen,
  handleSidebarToggle,
}: PropsWithoutRef<Props>) {
  const location = useLocation();
  const navigate = useNavigate();

  const drawer = (
    <>
      <Toolbar className="sidebar-logo" sx={{ position: "relative" }}>
        <figure
          className="logo_cntnr"
          style={{
            backgroundColor: "white",
            marginBottom: 10,
            padding: 6,
            borderRadius: "6px",
          }}
        >
          <img src="/static/images/logo.png" alt="" />
        </figure>
        <IconButton
          sx={{
            position: "absolute",
            top: "10px",
            right: "10px",
            color: "white",
            display: { lg: "none" },
          }}
          onClick={handleSidebarToggle}
        >
          <CloseIcon />
        </IconButton>
      </Toolbar>

      <List sx={{ flexGrow: 1 }} className="sidebr-lst">
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/dashboard"}
          onClick={() => navigate("/dashboard")}
        >
          <ListItemIcon>
            <DashboardIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Dashboard" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manageUsers" ||
            location.pathname === "/manageusers" ||
            location.pathname.startsWith("/manageusers/userdetails/") ||
            location.pathname.startsWith("/manageusers/usersform/")
          }
          onClick={() => navigate("/manageusers")}
        >
          <ListItemIcon>
            <PeopleIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Users" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-tutors" ||
            location.pathname.startsWith("/manage-tutors/details") ||
            location.pathname.startsWith("/manage-tutors/edit") ||
            location.pathname.startsWith("/manage-tutor/add") ||
            location?.pathname.startsWith(
              "/manage-tutor/details/NextTutorDetail"
            )
          }
          onClick={() => navigate("/manage-tutors")}
        >
          <ListItemIcon>
            <Person3Icon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Tutors" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-bookings" 
            // location.pathname.startsWith("/manage-bookings/details")
          }
          onClick={() => navigate("/manage-bookings")}
        >
          <ListItemIcon>
            <NoteIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Bookings" />
        </ListItemButton>


        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/online-booking" 
            
          }
          onClick={() => navigate("/online-booking")}
        >
          <ListItemIcon>
            <DuoIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Online Bookings" />
        </ListItemButton>

        {/* payment request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/paymentRequest" ||
            location.pathname.startsWith("/paymentRequestDetails")
          }
          onClick={() => navigate("/paymentRequest")}
        >
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Payment Request" />
        </ListItemButton>
        {/* refund request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/refundRequest" ||
            location.pathname.startsWith("/refundRequestDetails")
          }
          onClick={() => navigate("/refundRequest")}
        >
          <ListItemIcon>
            <KeyboardReturnIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Refund" />
        </ListItemButton>
        {/* refund request */}
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/payment" ||
            location.pathname.startsWith("/paymentDetails")
          }
          onClick={() => navigate("/payment")}
        >
          <ListItemIcon>
            <AttachMoneyIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Payment" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/customer-support"}
          onClick={() => navigate("/customer-support")}
        >
          <ListItemIcon>
            <HelpCenterIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Customer Support" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-reviews" ||
            location.pathname.startsWith("/manage-reviews/details")
          }
          onClick={() => navigate("/manage-reviews")}
        >
          <ListItemIcon>
            <ThumbUpIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Reviews" />
        </ListItemButton>

        <ListItemButton
          className="lst-itm"
          selected={
            location.pathname === "/manage-notifications" ||
            location.pathname === "/recieved-notifications" ||
            location.pathname === "/manage-notifications/add"
          }
          onClick={() => navigate("/manage-notifications")}
        >
          <ListItemIcon>
            <NotificationsActiveIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage Notifications" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/analytics"}
          onClick={() => navigate("/analytics")}
        >
          <ListItemIcon>
            <BarChartIcon />
          </ListItemIcon>
          <ListItemText
            className="lstitm-txt"
            primary="Reports and Analytics"
          />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/cms"}
          onClick={() => navigate("/cms")}
        >
          <ListItemIcon>
            <SummarizeTwoToneIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Manage CMS" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/faq"}
          onClick={() => navigate("/faq")}
        >
          <ListItemIcon>
            <QuizIcon />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary=" Manage FAQs" />
        </ListItemButton>
        <ListItemButton
          className="lst-itm"
          selected={location.pathname === "/manage-settings"}
          onClick={() => navigate("/manage-settings")}
        >
          <ListItemIcon>
            <Settings />
          </ListItemIcon>
          <ListItemText className="lstitm-txt" primary="Settings" />
        </ListItemButton>
      </List>
    </>
  );

  return (
    <Box
      component="nav"
      sx={{ flexShrink: { lg: 0 } }}
      className="sidebar-main-div"
    >
      <Drawer
        className="sidebar_drawer"
        variant="temporary"
        open={mobileOpen}
        onClose={handleSidebarToggle}
        ModalProps={{
          keepMounted: true,
        }}
        sx={{
          display: { xs: "block", lg: "none" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: SIDEBAR_WIDTH,
          },
        }}
      >
        {drawer}
      </Drawer>
      <Drawer
        variant="permanent"
        className="sidebar_drawer"
        sx={{
          display: { xs: "none", lg: "block" },
          "& .MuiDrawer-paper": {
            width: SIDEBAR_WIDTH,
            boxSizing: "border-box",
          },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  );
}
